<template>
  <div>
    <vue-progress-bar/>

    <product-filter
      @input="handleFilter"
      v-model="filter"
      :child-categories="childCategories"
      :tags="tags"
      :models="models"
      :filter-values="filterValues"/>

    <div v-infinite-scroll="handleLoadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
      <product-list :products="products"/>
    </div>

    <div v-if="false && pagesCount > 1">
      <nav class="pagination">
        <a
          @click="handlePageChange(page - 1)"
          :disabled="!(page > 1)"
          class="pagination-previous">Предыдущая
        </a>

        <a
          @click="handlePageChange(page + 1)"
          :disabled="!(page < pagesCount)"
          class="pagination-next">Следующая
        </a>

        <ul class="pagination-list gl-pagination">
          <li v-for="n in pagesCount">
            <a
              @click="handlePageChange(n)"
              :class="[n === page ? 'is-current' : '', 'pagination-link']">{{n}}
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import qs from 'query-string'
  import ProductFilter from './Filter'
  import ProductList from 'glonass/shop/site/widgets/product-list/Widget'
  import CrudApi from 'glonass/core/CrudApi'

  const props = {
    /**
     * Базовый URL страницы.
     * К нему будут добавляться параметры фильтрации.
     */
    baseUrl: {
      type: String,
      required: true
    },

    /**
     * Варианты фильтра
     */
    filterValues: {
      type: Object,
      required: true
    },

    /**
     * Первоначальное значение фильтра
     */
    initialFilter: {
      type: Object,
      required: true
    },

    initialProducts: {
      type: Array,
      required: true
    },

    initialCount: {
      type: Number,
      required: true
    },

    category: {
      type: Object,
      required: true
    },

    pageSize: {
      type: Number,
      required: true
    },

    sorting: {
      type: Object,
      default: () => ({
        field: 'sorting',
        order: 'asc'
      })
    },

    /**
     * Все дочерние разделы.
     */
    initialChildCategories: {
      type: Array,
      required: true
    },

    /**
     * Все модели преставленные в разделе без фильтрации.
     */
    initialModels: {
      type: Array,
      required: true
    },

    /**
     * Все модели преставленные в разделе без фильтрации.
     */
    initialTags: {
      type: Array,
      required: true
    }
  }

  const data = function () {
    return {
      api: new CrudApi('shop/site/product'),

      /**
       * Флаг загрузки.
       * Если значение true значит в данный момент идет http запрос
       */
      loading: false,

      /**
       * Отображаемые в данный моменты элементы списка
       * @var {*[]}
       */
      products: _.cloneDeep(this.initialProducts),

      /**
       * Количество всех проходящих по установленному фильтру записей
       */
      count: this.initialCount,

      /**
       * Выбранная страница
       */
      page: 1,

      /**
       * Фильтр.
       * Ключи - имена полей, значения представляют собой значения по умолчанию.
       */
      filter: _.cloneDeep(this.initialFilter),

      childCategories: this.initialChildCategories,
      models: this.initialModels,
      tags: this.initialTags
    }
  }

  /**
   * Список товаров раздела с фильтром и пагинацией.
   */
  export default {
    name: 'category-product-list',

    props,
    data,

    methods: {
      /**
       * Обработчик загрузки по бесконечному скроллу.
       */
      async handleLoadMore () {
        if (this.page < this.pagesCount) {
          this.page = this.page + 1
          this.loadPage()
        }
      },

      handlePageChange (page) {
        this.page = page
        this.loadPage()
      },

      handleFilter () {
        this.page = 1

        history.pushState(this.filter, 'Поиск: ' + this.category.name, this.getFilterUrl())

        this.loadPage(false)
      },

      async loadPage (changePage = true) {
        this.loading = true
        this.$Progress.start()

        try {
          const data = await this.getData(
            this.page,
            this.pageSize,
            this.sorting,
            {categoryId: this.category.id, ...this.filter}
          )

          this.childCategories = data.childCategories
          this.count = data.initialCount
          this.filter = data.initialFilter
          this.models = data.models
          this.tags = data.tags

          if (changePage) {
            this.products = _.concat(this.products, data.products)
          } else {
            // по фильтру
            this.products = data.products
          }
        } catch (e) {
          console.error(e)
        } finally {
          this.loading = false
          this.$Progress.finish()
        }
      },

      async getData (page, size, sorting, filter) {
        const {data} = await this.api.load({page, size}, sorting, filter, ['media', 'offers'])

        return data
      },

      getFilterUrl () {
        const url = new URL(this.baseUrl)
        const params = {...qs.parse(url.search), ...this.filter}

        if (this.page > 1) {
          params['page'] = this.page
        }

        const query = qs.stringify(params, {arrayFormat: 'index'})

        return url.origin + url.pathname + (query ? '?' + query : '')
      }
    },

    computed: {
      pagesCount () {
        return Math.ceil(this.count / this.pageSize)
      }
    },

    components: {
      ProductFilter,
      ProductList
    }
  }
</script>

<style scoped lang="scss">
  .gl-list {
    flex-wrap: wrap
  }

  .gl-pagination {
    list-style: none
  }
</style>



// WEBPACK FOOTER //
// Widget.vue?b92e3d0a